module.exports = __webpack_public_path__ + "static/img/announcement-icon.c0f03556.svg";